import {API} from "../../backend";
import { objectToQueryString } from "../../lib/utils";

export const saveEnquiry=(data)=>{
    return fetch(`${API}/save/enquiries`,{
        method: "POST",
        headers:{
            Accept: "application/json",
            'Content-type':"application/json"
        },
        body:JSON.stringify(data)
    })
    .then(response => {
        return response.json();
    })
    .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const getAllEnquiries = (userId, token,query) => {
    let str=objectToQueryString(query);
    return fetch(`${API}/enquiries/${userId}?${str}`, {
        method: 'GET',
        headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};

export const checkExistingEnquiry = (query) => {
    let str=objectToQueryString(query);
    return fetch(`${API}/existing-enquiry/check?${str}`, {
        method: 'GET',
        headers: {
            "Content-type": "application/json"
        }
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const getEnquiryCount = (userId, token,query) => {
    let str=objectToQueryString(query);
    return fetch(`${API}/enquiries/count/${userId}?${str}`, {
        method: 'GET',
        headers: {
            "Accept": "application/json",
            Authorization: `Bearer ${token}`
        }
    }).then(response => {
        return response.json();
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};
export const deleteSelectedEnquiries=(userId,token,data)=>{
    return fetch(`${API}/delete/enquiry/${userId}`,{
        method:'post',
        headers:{
            Accept:'application/json',
            Authorization:`bearer ${token}`,
            'Content-type':"application/json"
        },
        body:JSON.stringify(data)
    }).then(response=>response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const convertEnqToMember=(userId,token,data)=>{
    return fetch(`${API}/convert-enquiry-to-member/${userId}`,{
        method:'post',
        headers:{
            Accept:'application/json',
            Authorization:`bearer ${token}`,
            'Content-type':"application/json"
        },
        body:JSON.stringify(data)
    }).then(response=>response.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};